import { AutoevaluationStatus } from '../interfaces/autoevaluation/autoevaluation.entity';
import { pmiPlanStatus } from '../interfaces/pmi/plan.entity';
import { GoalData } from '../modules/ruta/components/plan/formulario/formulario.component';

export const getAutoevaluationStatusLabel = (status: AutoevaluationStatus) => {
	switch (status) {
		case 4:
			return 'Sin terminar';
		case 3:
			return 'Sin iniciar';
		case 2:
			return 'En revisión';
		case 1:
			return 'Cerrado';
		default:
			return 'En construcción';
	}
};

export const getPmiStatusLabel = (status: pmiPlanStatus) => {
	switch (status) {
		case 5:
			return 'Sin iniciar';
		case 4:
			return 'No completado';
		case 3:
			return 'En revisión';
		case 2:
			return 'Finalizado';
		case 1:
			return 'Cerrado';
		default:
			return 'En construcción';
	}
};

export const getAutoevaluationStatusColor = (status: AutoevaluationStatus) => {
	switch (status) {
		case 4:
			return 'danger';
		case 3:
			return 'info';
		case 2:
			return 'warning';
		case 1:
			return 'muted';
		default:
			return 'success';
	}
};

export const getClassPmiStatusColor = (status: pmiPlanStatus) => {
	switch (status) {
		case 5:
			return 'info';
		case 4:
			return 'danger';
		case 3:
			return 'warning';
		case 2:
			return '';
		case 1:
			return 'muted';
		default:
			return 'success';
	}
};

export const getAutoevaluationAverageColor = (average: number) => {
	if (average <= 2.5) {
		return 'danger';
	} else {
		return 'success';
	}
};

export const getAutoevaluationProgressColor = (progress: number) => {
	if (progress <= 50) {
		return 'danger';
	} else if (progress <= 75) {
		return 'warning';
	} else {
		return 'success';
	}
};

export const getPmiStatusColor = (status: pmiPlanStatus) => {
	switch (status) {
		case 5:
			return 'text-info';
		case 2:
		case 1:
			return 'text-muted';
		case 3:
			return 'text-warning';
		case 4:
			return 'text-danger';
		default:
			return 'text-success';
	}
};

export const validateGoalRequired = (goal: GoalData, withBudget?: boolean) => {
	let budgetData = true;
	if (withBudget) {
		budgetData = !!goal.id_funding_source && !!goal.expense_description && goal.expense_value !== null;
	}

	return (
		!!goal.goal && !!goal.actions
		&& !!goal.indicator && !!goal.start_date
		&& !!goal.end_date && !!goal.id_responsible
		&& budgetData
	);
};

export const validateGoalWithData = (goal: GoalData) => {
	return (
		!!goal.goal || !!goal.actions
		|| !!goal.indicator || !!goal.start_date
		|| !!goal.end_date || !!goal.id_responsible
	);
};